export const StephLotze = () => {
  return (
    <div>
      {" "}
      <div
        className=""
        id="stephLotzeModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contactModalLabel"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body" style={{ height: "100%" }}>
              <div className="row">
                <div className="col-lg-4">
                  <img
                    className="profile-image"
                    src="/images/executioners/stephlotze.jpg"
                    alt="Steph Lotze"
                    style={{ margin: "10px 0" }}
                  />
                </div>
                <div className="col-lg-8">
                  <div className="modal-title-container">
                    <h4 className="modal-title" id="contactModalLabel">
                      Steph Lotze
                    </h4>
                    <p>Photographer / Visual Communicator</p>
                    <p style={{ paddingTop: "17px" }}>
                      <strong>"Too soon to tell..."</strong>
                    </p>
                  </div>
                  <div className="modal-body-container">
                    <p>
                      During the last 10 years, Stephanie Lotze’s travels and
                      photography have inspired her to capture moments of nature
                      in collision with composition. The irony of a redwood
                      picnic table dwarfed by first growth redwoods, the scale
                      of a human against the vast backdrop of mountains, water,
                      snow and light or the exact right smile of a person’s
                      eyes.
                    </p>

                    <p>
                      Ms. Lotze photographs products with the same eye for the
                      unexpected. She lends both talent and insight to a variety
                      of projects at Big Blue Fish.
                    </p>

                    <p>
                      Ever absorbed in composing the essence of a thing, she
                      also turns her hand to illustrations, often-simple lines
                      of whimsy capturing archetypal images and themes.
                    </p>

                    <p>
                      “I’m a storyteller of no words. Using only light and
                      lines,” says Stephanie, “I’m a preservationist of
                      landscapes, brands, how a person appears in a moment in
                      time, or how we might all appear...”
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-default"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
